const generateRedirectUrl = ({
  websiteToken,
  channelType,
  visitorId,
  name,
  phoneNumber,
  emailAddress,
  customAttributes,
  opportunityCustomAttributes,
  vsid,
  vvid,
  vsrc,
}) => ({
  url: `/pre-chat/${channelType}/${websiteToken}/generate_redirect_url`,
  data: {
    visitor_id: visitorId,
    name,
    phone_number: phoneNumber,
    email: emailAddress,
    custom_attributes: customAttributes,
    opportunity_custom_attributes: opportunityCustomAttributes,
    vsid,
    vvid,
    vsrc,
  },
});

export default {
  generateRedirectUrl,
};
